import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const containerStyle = css`
  display: flex;
  align-items: center;
  gap: ${theme.spacing(1)};
  flex: 1;
  overflow: hidden;
`;

export const patronDetailsContainerStyle = css`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing(0.5)};
  flex: 1;
  overflow: hidden;
`;

export const nameAndIdContainerStyle = css`
  display: flex;
  align-items: center;
  gap: ${theme.spacing(1)};
`;

export const moreInfoContainerStyle = css`
  display: flex;
  align-items: center;
`;

/**
 * Shows a dotted separator before the element it is applied to.
 */
export const dottedSeparatorStyle = css`
  &::before {
    content: '';
    display: inline-block;
    width: 4px;
    height: 4px;
    background-color: ${theme.colors.neutral20};
    border-radius: 50%;
    margin: ${theme.spacing(0, 1)};
    flex-shrink: 0;
  }
`;

/**
 * Shows a vertical line separator before the element it is applied to.
 */
export const verticalLineSeparatorStyle = css`
  &::before {
    content: '|';
    display: inline-block;
    height: 100%;
    border-left: 2px solid ${theme.colors.neutral20};
    margin: ${theme.spacing(0, 1)};
    color: transparent;
  }
`;
